// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropzone-over{-webkit-box-shadow:0 0 5px #51cbee;box-shadow:0 0 5px #51cbee;border:1px solid #51cbee}", ""]);
// Exports
module.exports = exports;
